import { render, staticRenderFns } from "./SitePermsTable.vue?vue&type=template&id=1a21e90e&"
import script from "./SitePermsTable.vue?vue&type=script&lang=ts&"
export * from "./SitePermsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports